import React, { useContext, useEffect, useState } from 'react'
import { ApiGetCall } from '../../JS/Connector';
import { LogInSchoolID, MMDDYYYY } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { UserContext } from '../../App';

export default function DownloadOpenTicketReport({ setAlerts }) {
    const [helpdeskReportData, setHelpdeskReportData] = useState([]);
    const { UserData } = useContext(UserContext);
    useEffect(() => {
        GetHelpdeskReportData();
    }, []);
    async function GetHelpdeskReportData() {
        await ApiGetCall("/HelpdeskTicketByBuildingforReport/" + LogInSchoolID).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setHelpdeskReportData(responseRs?.HelpdeskTicketByBuildingforReport?.pdfData);
            }
        });
    }
    const downloadCsv = () => {
        const csvContent = [];
        const gradeMap = new Map();
        helpdeskReportData?.forEach((buildingTickets) => {
            if (buildingTickets.length > 0) {
                var building = "";
                if (UserData.helpdeskUpdatedFlag) {
                    building = buildingTickets[0]?.building?.name || buildingTickets[0]?.building_name // Get the building name
                } else {
                    building = buildingTickets[0]?.building?.name || buildingTickets[0]?.other_building_name // Get the building name
                }
                if (!gradeMap.has(building)) {
                    gradeMap.set(building, []);
                }
                buildingTickets.forEach((ticket) => {
                    var tickettype = "";
                    if (UserData.helpdeskUpdatedFlag) {
                        tickettype = ticket?.type?.name;
                    } else {
                        tickettype = ticket?.type == 1 ? "Technology" : "Maintenance"
                    }
                    const rowData = {
                        'Subject': ticket.title,
                        'Name': ticket?.name,
                        'Email': ticket?.email,
                        'Room': ticket?.room_name ? ticket?.room_name : ticket.room ? ticket?.room?.name : '-',
                        'Student No.': ticket?.student_no,
                        'Created at': MMDDYYYY(ticket.created_at),
                        'Assigned To': ticket?.assigned_flag == 1 ?
                            ticket?.usergroup?.name :
                            ticket?.assigned_flag == 2 ?
                                `${ticket?.user?.first_name} ${ticket?.user?.last_name}`
                                : '-',  // Format the date
                        'Ticket Type': tickettype,
                    };

                    gradeMap.get(building).push(rowData);
                });
            }
        });


        gradeMap.forEach((gradeData, building) => {
            csvContent.push([`Building: ${building}`]);
            const headers = ['Subject', 'Name', 'Email', 'Room', 'Student No.', 'Created at', 'Assigned To', 'Ticket Type'];
            csvContent.push(headers);
            gradeData.forEach((rowData) => {
                const values = Object.values(rowData);
                csvContent.push(values);
            });
            csvContent.push([]);
        });

        if (csvContent.length > 0) {
            const csvString = csvContent.map(row => row.join(',')).join('\n'); // Convert to CSV string
            const blob = new Blob([csvString], { type: 'text/csv' });  // Create a Blob with the CSV content
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'OpenTicketsReport.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            setAlerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
            setTimeout(() => {
                setAlerts(<AlertsComp show={false} />)
            }, 1500);
        }
    };
    return (
        <label className='BorderBtn me-1 text-center' title="Create Main Category" onClick={downloadCsv}>
            <img src='/images/downloadPlan.svg' className='img-fluid pe-2' />Open Tickets Report
        </label>
    )
}
